import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingModuleConfigurationsPaginated, moduleConfigurationClean } from "../../app/actions/moduleConfigurationActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsModuleConfigurations = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewModuleConfigurations", event: "NewModuleConfigurations-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListModuleConfigurations", event: "ListModuleConfigurations-Clicked" });
      dispatch(cleanSearchingModuleConfigurationsPaginated());
    }

    dispatch(moduleConfigurationClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listModuleConfigurations" && (
        <Link
          data-tip
          data-for="newModuleConfigurationsTip"
          to="/admin-module-configuration/new-module-configuration"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newModuleConfigurations" && (
        <Link
          data-tip
          data-for="listModuleConfigurationsTip"
          to="/admin-module-configuration/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editModuleConfigurations" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listModuleConfigurationsTip"
            to="/admin-module-configuration/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newModuleConfigurationsTip"
            to="/admin-module-configuration/new-module-configuration"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newModuleConfigurationsTip" place="left" effect="solid">
        {t("admin-module-configuration.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listModuleConfigurationsTip" place="left" effect="solid">
        {t("admin-module-configuration.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsModuleConfigurations;
